import { useQueryClient } from '@tanstack/react-query';

import { protocolosApi } from '../api';
import { BULK_BATCH_SIZE, BULK_MAX_CONCURRENT_BATCHES } from '../constants';
import type { BulkResponseConsolidada } from '../types';
import { orquestarBatches } from '../utils/orquestarBatches';
import { protocolosKeys } from './useProtocolos';

interface RunParams {
  uids: string[];
  onProgress?: (procesados: number, total: number) => void;
}

export function useBulkCerrar() {
  const queryClient = useQueryClient();

  async function run({ uids, onProgress }: RunParams): Promise<BulkResponseConsolidada> {
    const result = await orquestarBatches({
      uids,
      batchSize: BULK_BATCH_SIZE,
      maxConcurrent: BULK_MAX_CONCURRENT_BATCHES,
      procesarBatch: (batchUids) => protocolosApi.bulkCerrar(batchUids),
      onProgress,
    });
    void queryClient.invalidateQueries({ queryKey: protocolosKeys.all });
    return result;
  }

  return { run };
}
